import { Button } from 'components/button/button';
import { useTranslation } from 'hooks/use-translation';
import { FunctionalComponent, h } from 'preact';
import './la-login.scss';

interface LALoginProps {
  ssoLogin: () => void;
  authProgressStatus: string;
  loginBtnTextPath: string;
}

export const LALogin: FunctionalComponent<LALoginProps> = ({
  ssoLogin,
  authProgressStatus,
  loginBtnTextPath,
}) => {
  const { translate } = useTranslation();

  return (
    <form className="la-login__form" name="form" noValidate>
      <div className="la-login__logo">
        <img src="./frontend/images/login-la-logo.svg" alt="Level Access logo" />
      </div>
      <p className="la-login__info">{translate('widget.login.info_la')}</p>
      <Button
        id="login-button-el"
        onClick={ssoLogin}
        className="la-login__button"
        disabled={authProgressStatus === 'loading'}
      >
        {translate(loginBtnTextPath)}
      </Button>
    </form>
  );
};
